import { Box, MenuItem } from "@mui/material";
import type React from "react";

export default function ChannelContextItem({
  text,
  disabled,
  label,
  channelContextAction,
  icon,
}: {
  text: string;
  disabled: boolean;
  label: string;
  channelContextAction: () => void;
  icon?: React.ReactElement | string;
}) {
  return (
    <MenuItem
      sx={{ display: "flex", justifyContent: "flex-start", gap: 1, alignItems: "center" }}
      aria-label={label}
      disabled={disabled}
      onClick={channelContextAction}
    >
      {icon && (
        <Box sx={{ display: "flex", width: "30px", justifyContent: "center", alignItems: "center" }}>
          <>{icon}</>
        </Box>
      )}
      <Box>{text}</Box>
    </MenuItem>
  );
}
